<template>
  <div id="m-government">
    <div style="position: relative">
      <p style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);color: #fff;font-size: 1.3rem;font-weight: 500;">{{solutionDetail.fsolutionName}}</p>
      <img :src='baseUrl+solutionDetail.fsolutionUrl' width="100%" />
    </div>
    <div id="div_content" class="cases_wrap">
      <div class="cases_list">
        <div class="text" v-html="solutionDetail.fsolution">
        </div>
      </div>
      <div class="cases_list">
        <h2>成功案例</h2>
        <div class="text">
          <div id="div_caseList" class="cases_slide" v-html="CaseDate.fcase">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "../../../../static/js/commonAxios";
  import $ from "jquery";

  export default {
    name: "government",
    data(){
      return{
        // solutionId:this.$route.query.id,
        solutionDetail: {},
        CaseDate: '',
        baseUrl: ''
      }
    },
    computed: {
      getsolutionId() {
        return this.$store.state.solutionId
      }
    },
    watch: {
      getsolutionId: {
        handler(val) {
          this.getSolutionDetailDate(val)
        },
        deep:true
      }
    },
    mounted(){
      this.baseUrl = process.env.API_ROOT;
      this.getSolutionDetailDate(this.getsolutionId)
    },
    methods: {
      getSolutionDetailDate(id){
        axios.get(`/api/solution/${id}`).then((res) => {
          if(res.data.success){
            this.solutionDetail = res.data.items[0]
            this.$nextTick(()=>{
              $('.cases_main .fixed li a').removeClass('active')
              $("#"+id).addClass('active')
            })
            this.getCaseDate(id)
          }else{
            this.$message({
              type: 'warning',
              message: res.data.msg
            });
          }
        })
      },
      getCaseDate(id){
        axios.get(`/api/case?fsolutionId=${id}`).then((res) => {
          if(res.data.success){
            this.CaseDate = res.data.items[0]
          }else{
            this.$message({
              type: 'warning',
              message: res.data.msg
            });
          }
        })
      },
    },
  }
</script>

<style>
  #m-government {
    background-color: #fff;
  }
  #m-government #div_content {
    padding: 0 2rem 4.3rem 2rem;
  }
  #m-government .cases_list {
    padding-top: 3.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/mobileSolutionDetail/mobileSolutionDetail.vue